export default class RoboticAiStatuses {
  static UNKNOWN = "0:unknown";

  static AWAITING_CATEGORIZATION = "1:awaitingCategorization";

  static AWAITING_CLARIFICATION = "2:awaitingClarification";

  static AWAITING_DOCUMENT = "3:awaitingDocument";

  static AWAITING_REVIEW = "4:awaitingReview";

  static AWAITING_EXPORT = "5:awaitingExport";

  static AWAITING_RECONCILIATION = "6:awaitingReconciliation";
}
